import script from "./ProspectosView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProspectosView.vue?vue&type=script&setup=true&lang=js"

import "./ProspectosView.vue?vue&type=style&index=0&id=340ecf49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-340ecf49"]])

export default __exports__